document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('product-form').forEach(function (productFormEl) {
    var form = productFormEl.querySelector('form');
    if (!form) return;

    var container = productFormEl.closest('.product, .product-info, product-info') || document;
    var selector = container.querySelector('[data-product-addon-selector]') || document.querySelector('[data-product-addon-selector]');
    if (!selector) return;

    var submitButton = form.querySelector('[type="submit"]');
    if (!submitButton) return;

    submitButton.addEventListener('click', function (evt) {
      var checked = selector.querySelectorAll('input[type="checkbox"]:checked');
      if (!checked.length) return; // no add-ons selected, let the theme's normal add-to-cart flow proceed untouched

      evt.preventDefault();

      var variantInput = form.querySelector('[name="id"]');
      var quantityInput = form.querySelector('[name="quantity"]');
      var mainVariantId = variantInput ? variantInput.value : null;
      if (!mainVariantId) return;

      var items = [{ id: mainVariantId, quantity: quantityInput ? (parseInt(quantityInput.value, 10) || 1) : 1 }];
      checked.forEach(function (cb) {
        items.push({ id: cb.getAttribute('data-addon-variant-id'), quantity: 1 });
      });

      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { items: items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            console.error('Add-on cart add failed:', response.errors || response.description);
            return;
          }
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(response);
          } else {
            window.location = window.routes.cart_url;
          }
        })
        .catch(function (e) { console.error(e); })
        .finally(function () {
          submitButton.removeAttribute('aria-disabled');
          submitButton.classList.remove('loading');
        });
    });
  });
});
